<div class="skeleton">
    <div class="skeleton_item">
        <div class="skeleton_header ">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
        <div class="skeleton_container">
            <p>
                <ion-skeleton-text animated style="width: 15%"></ion-skeleton-text>
            </p>
            <div class="skeleton_details">
                <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
            </div>
        </div>


    </div>
    <div class="skeleton_item">
        <div class="skeleton_header box_shadow">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
    </div>
    <div class="skeleton_item">
        <div class="skeleton_header box_shadow">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
    </div>
    <div class="skeleton_item">
        <div class="skeleton_header box_shadow">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
    </div>
    <div class="skeleton_item">
        <div class="skeleton_header box_shadow">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
    </div>
    <div class="skeleton_item">
        <div class="skeleton_header box_shadow">
            <p>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </p>
            <div class="classement">
                <p>
                    <ion-skeleton-text animated style="width: 45%; margin: auto;"></ion-skeleton-text>
                </p>
            </div>
        </div>
    </div>

</div>